import { NextPage, NextPageContext } from 'next'
import { PageType } from '@core/utils/pages/types'

/**
 * Page HOC for extending initial props with the page type default prop
 * @param pageType
 */
export const withPageType =
  (pageType: PageType) =>
  <TComponent extends NextPage>(component: TComponent): TComponent => {
    const originalGetInitialProps = component.getInitialProps

    component.getInitialProps = async (ctx: NextPageContext) => {
      const pageProps = originalGetInitialProps
        ? await originalGetInitialProps(ctx)
        : {}

      return {
        pageType,
        ...pageProps,
      }
    }

    return component
  }
